<template>
	<h-tab-group as="div" v-bind="groupProperties" @change="onChange">
		<slot></slot>
	</h-tab-group>
</template>

<script setup lang="ts">
const properties = defineProps<{
	syncWithUrl?: boolean;
}>();

const emit = defineEmits<{
	(event: "change", index: number): void;
}>();

const route = useRoute();
const router = useRouter();

// URL hash isn't available on the server, so apply it only after mount to avoid hydration mismatches.
// Tabs <-> URL's could have a more permanent and stable mapping but historycally this has only been a client side feature.
const selectedIndex = ref(0);

onMounted(() => {
	if (properties.syncWithUrl && route.hash) {
		selectedIndex.value = Number(route.hash.replace(/^#t/, ""));
	}
});

// Don't pass `selectedIndex` if url syncing isn't requested, to keep the component uncontrolled.
const groupProperties = computed(() =>
	properties.syncWithUrl
		? {
				selectedIndex: selectedIndex.value,
			}
		: {},
);

function onChange(index: number) {
	emit("change", index);
	selectedIndex.value = index;
	if (selectedIndex.value === 0) {
		router.replace(route.fullPath.replace(/#t\d+$/, ""));
		return;
	}
	router.replace(`${route.fullPath.replace(/#.*$/, "")}#t${index}`);
}
</script>
